import http from '../axios';

export function index() {
  return http.get('/service_catalog_pricings');
}

export function save_service(service_catalog_pricing) {
  return http.post('/service_catalog_pricings/save_service', {service_catalog_pricing});
}